function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.124 5.417l1.157.941.004.106a5.403 5.403 0 00-.246 1.583c0 .551.093 1.085.254 1.583l-.166.135.232-.175.096-.008a4.928 4.928 0 004.668 3.325c1.222 0 2.152-.33 2.844-.8 1.094-.747 1.587-1.858 1.678-2.596H8.123V6.542h7.704c.118.498.173.978.173 1.636 0 2.435-.893 4.489-2.443 5.884C12.198 15.29 10.338 16 8.123 16c-3.19 0-5.948-1.774-7.306-4.362l-.002.002a8.324 8.324 0 010-7.186l.023-.011-.045-.034C2.143 1.796 4.913 0 8.123 0c2.215 0 4.066.791 5.488 2.08l-2.315 2.204c-.593-.542-1.632-1.19-3.173-1.19a4.949 4.949 0 00-4.677 3.324L2.124 5.417z",
  fill: "currentColor",
  fillRule: "nonzero"
});

function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgGoogle;